/* Additive gallery controls. Native Dawn media-gallery remains the source of truth. */
if (!customElements.get('zr-product-gallery')) {
  customElements.define('zr-product-gallery', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.querySelector('media-gallery');
      if (!this.gallery) return;
      this.onClick = (event) => {
        const button = event.target.closest('[data-zr-step]');
        if (!button || !this.contains(button)) return;
        const slides = this.slides();
        const index = this.currentIndex(slides);
        const next = slides[index + Number(button.dataset.zrStep)];
        if (next && typeof this.gallery.setActiveMedia === 'function') {
          this.gallery.setActiveMedia(next.dataset.mediaId, false);
        }
      };
      this.addEventListener('click', this.onClick);
      this.onSlideChanged = () => this.sync();
      this.gallery.addEventListener('slideChanged', this.onSlideChanged);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-current'] });
      this.onResize = () => this.sync();
      window.addEventListener('resize', this.onResize);
      // Enhancement activates only after Dawn's gallery custom element is ready.
      customElements.whenDefined('media-gallery').then(() => {
        if (!this.isConnected) return;
        const controls = this.querySelector('.zr-gallery-arrows');
        if (controls) controls.hidden = false;
        this.sync();
      });
    }
    slides() { return Array.from(this.gallery.querySelectorAll('[id^="Slider-Gallery-"] > [data-media-id]')); }
    currentIndex(slides) {
      if (window.matchMedia('(max-width: 749px)').matches) {
        const selected = this.gallery.querySelector('[id^="Slider-Thumbnails-"] button[aria-current="true"]')?.closest('[data-target]');
        if (selected) return Math.max(0, slides.findIndex(slide => slide.dataset.mediaId === selected.dataset.target));
      }
      return Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    }
    sync() {
      const slides = this.slides();
      const index = this.currentIndex(slides);
      this.querySelectorAll('[data-zr-step]').forEach(button => {
        const disabled = !slides[index + Number(button.dataset.zrStep)];
        if (button.disabled !== disabled) button.disabled = disabled;
      });
      // Dawn scrolls thumbnails horizontally. Add vertical visibility on desktop,
      // including variant media updates and keyboard thumbnail selection.
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      const track = this.gallery.querySelector('[id^="Slider-Thumbnails-"]');
      const active = track?.querySelector('button[aria-current="true"]')?.closest('li');
      if (!track || !active) return;
      const box = track.getBoundingClientRect();
      const item = active.getBoundingClientRect();
      if (item.top < box.top) track.scrollTop -= box.top - item.top;
      else if (item.bottom > box.bottom) track.scrollTop += item.bottom - box.bottom;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.gallery?.removeEventListener('slideChanged', this.onSlideChanged);
      window.removeEventListener('resize', this.onResize);
    }
  });
}
